var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { useOkapiKy } from "@folio/stripes/core";
import { Accordion, AccordionSet, Button, Col, MessageBanner, Pane, PaneFooter, Row, } from "@folio/stripes/components";
import { FormattedMessage, useIntl } from "react-intl";
import { useParams } from "react-router";
import { useForm, Controller } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { useQuery } from "react-query";
import { RecekSelect, RecekTextField } from "../../components/inputs";
import { ExpandableFieldErrors } from "../../components/inputs/ExpandableFieldErrors";
import { createPublisherPrefixRange, fetchPublisherPrefixRangeById, updatePublisherPrefixRange, } from "../../api/publisherPrefixRange";
import { fetchAllAgencyPrefixes, fetchValidMagnitudes, } from "../../api/agencyPrefixesService";
import { navigation } from "../../components/navigation";
import { RecekPaneSet } from "../../components/RecekPaneSet";
import { createPublisherPrefixRangeSchema } from "../../utils/validationUtils";
import { useAccordion } from "../../utils/useAccordion";
import { toErrorWithResponse } from "../../utils/httpErrors";
import { handlePublisherPrefixRangeError, applyFieldErrors, } from "../../utils/publisherPrefixRangeErrorHandler";
import { PublisherPrefixRangeStatusEnum, } from "../../types/Api";
import { useScrollToError } from "../../hooks/useScrollToError";
function PublisherPrefixRangeForm() {
    var _this = this;
    var _a;
    var history = useHistory();
    var ky = useOkapiKy();
    var formatMessage = useIntl().formatMessage;
    var id = useParams().id;
    var _b = useQuery(["agency-prefixes"], function () { return fetchAllAgencyPrefixes(ky); }, {}), data = _b.data, isLoading = _b.isLoading;
    var _c = useAccordion({ general: true }), accordionStatus = _c.accordionStatus, toggleAccordion = _c.toggleAccordion;
    var _d = useState(!!id), editMode = _d[0], setEditMode = _d[1];
    var _e = useState({}), serverFieldErrors = _e[0], setServerFieldErrors = _e[1];
    var _f = useState([]), generalErrors = _f[0], setGeneralErrors = _f[1];
    var _g = useForm({
        resolver: zodResolver(createPublisherPrefixRangeSchema(formatMessage)),
        shouldFocusError: false,
        defaultValues: {
            agencyPrefix: { id: "", internationalPrefix: {}, value: "" },
            magnitude: 1,
            start: "0",
            end: "0",
            status: PublisherPrefixRangeStatusEnum.ACTIVE,
            nextSequence: "0",
            version: 0,
        },
        mode: "onBlur",
    }), control = _g.control, handleSubmit = _g.handleSubmit, reset = _g.reset, watch = _g.watch, setValue = _g.setValue, setError = _g.setError, errors = _g.formState.errors;
    var selectedAgencyPrefixId = (_a = watch("agencyPrefix")) === null || _a === void 0 ? void 0 : _a.id;
    var _h = useQuery(["valid-magnitudes", selectedAgencyPrefixId], function () { return fetchValidMagnitudes(ky, selectedAgencyPrefixId); }, { enabled: !!selectedAgencyPrefixId && !editMode }), magnitudeData = _h.data, isMagnitudeLoading = _h.isLoading;
    useEffect(function () {
        if ((magnitudeData === null || magnitudeData === void 0 ? void 0 : magnitudeData.minMagnitude) != null &&
            (magnitudeData === null || magnitudeData === void 0 ? void 0 : magnitudeData.maxMagnitude) != null) {
            setValue("magnitude", magnitudeData.minMagnitude);
        }
    }, [magnitudeData, setValue]);
    useEffect(function () {
        if (id) {
            (function () { return __awaiter(_this, void 0, void 0, function () {
                var data_1, error_1;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            _a.trys.push([0, 2, , 3]);
                            return [4 /*yield*/, fetchPublisherPrefixRangeById(ky, id)];
                        case 1:
                            data_1 = _a.sent();
                            reset(data_1);
                            setEditMode(true);
                            return [3 /*break*/, 3];
                        case 2:
                            error_1 = _a.sent();
                            console.error("Error fetching publisher prefix range:", error_1);
                            return [3 /*break*/, 3];
                        case 3: return [2 /*return*/];
                    }
                });
            }); })();
        }
    }, [id, reset]);
    useScrollToError(errors);
    var getAgencyPrefixById = function (prefixId) { var _a; return (_a = data === null || data === void 0 ? void 0 : data.items) === null || _a === void 0 ? void 0 : _a.find(function (prefix) { return prefix.id === prefixId; }); };
    var handleFormSubmit = function (data) { return __awaiter(_this, void 0, void 0, function () {
        var payload, caught_1, error, errorsJson, _a, fieldErrors, genErrors, _b;
        var _c, _d, _e, _f, _g;
        return __generator(this, function (_h) {
            switch (_h.label) {
                case 0:
                    setServerFieldErrors({});
                    setGeneralErrors([]);
                    payload = __assign(__assign({}, data), { agencyPrefix: {
                            id: (_c = data === null || data === void 0 ? void 0 : data.agencyPrefix) === null || _c === void 0 ? void 0 : _c.id,
                            internationalPrefix: (_d = data === null || data === void 0 ? void 0 : data.agencyPrefix) === null || _d === void 0 ? void 0 : _d.internationalPrefix,
                            value: (_e = data === null || data === void 0 ? void 0 : data.agencyPrefix) === null || _e === void 0 ? void 0 : _e.value,
                        } });
                    _h.label = 1;
                case 1:
                    _h.trys.push([1, 6, , 11]);
                    if (!editMode) return [3 /*break*/, 3];
                    return [4 /*yield*/, updatePublisherPrefixRange(ky, payload)];
                case 2:
                    _h.sent();
                    return [3 /*break*/, 5];
                case 3: return [4 /*yield*/, createPublisherPrefixRange(ky, payload)];
                case 4:
                    _h.sent();
                    _h.label = 5;
                case 5:
                    history.push(navigation.publisherPrefixRanges.path);
                    return [3 /*break*/, 11];
                case 6:
                    caught_1 = _h.sent();
                    error = toErrorWithResponse(caught_1);
                    if (((_f = error === null || error === void 0 ? void 0 : error.response) === null || _f === void 0 ? void 0 : _f.status) === 409) {
                        setGeneralErrors([
                            formatMessage({
                                id: "ui-br-agency.publisher-prefix-range.submit.duplicity",
                            }),
                        ]);
                        return [2 /*return*/];
                    }
                    _h.label = 7;
                case 7:
                    _h.trys.push([7, 9, , 10]);
                    return [4 /*yield*/, ((_g = error === null || error === void 0 ? void 0 : error.response) === null || _g === void 0 ? void 0 : _g.json())];
                case 8:
                    errorsJson = _h.sent();
                    _a = handlePublisherPrefixRangeError(errorsJson, formatMessage), fieldErrors = _a.fieldErrors, genErrors = _a.generalErrors;
                    setServerFieldErrors(fieldErrors);
                    applyFieldErrors(fieldErrors, setError);
                    if (genErrors.length > 0) {
                        setGeneralErrors(genErrors);
                    }
                    return [3 /*break*/, 10];
                case 9:
                    _b = _h.sent();
                    setGeneralErrors([
                        formatMessage({ id: "ui-br-agency.general.server.error.message" }) +
                            " : " +
                            ((error === null || error === void 0 ? void 0 : error.message) || "Unknown error occurred"),
                    ]);
                    return [3 /*break*/, 10];
                case 10: return [3 /*break*/, 11];
                case 11: return [2 /*return*/];
            }
        });
    }); };
    var footer = (React.createElement(PaneFooter, { renderStart: React.createElement(Button, { buttonStyle: "primary", type: "submit", onClick: handleSubmit(handleFormSubmit) },
            React.createElement(FormattedMessage, { id: "ui-br-agency.button.save" })), renderEnd: React.createElement(Button, { buttonStyle: "default", onClick: function () { return history.push(navigation.publisherPrefixRanges.path); } },
            React.createElement(FormattedMessage, { id: "ui-br-agency.button.cancel" })) }));
    if (isLoading)
        return null;
    return (React.createElement(RecekPaneSet, null,
        React.createElement(Pane, { id: "contentPane", defaultWidth: "fill", paneTitle: formatMessage({
                id: editMode
                    ? "ui-br-agency.publisher-prefix-range.pane.label.edit"
                    : "ui-br-agency.publisher-prefix-range.pane.label.create",
            }), footer: footer },
            generalErrors.length > 0 && (React.createElement(MessageBanner, { type: "error", dismissible: true, onExited: function () { return setGeneralErrors([]); } }, generalErrors.length === 1 ? (generalErrors[0]) : (React.createElement("ul", { style: { margin: 0, paddingLeft: "1.5em" } }, generalErrors.map(function (err, i) { return (React.createElement("li", { key: i }, err)); }))))),
            React.createElement("form", { noValidate: true, onSubmit: handleSubmit(handleFormSubmit) },
                React.createElement(AccordionSet, null,
                    React.createElement(Accordion, { label: formatMessage({
                            id: "ui-br-agency.publisher-prefix-range.accordions.label.general",
                        }), open: accordionStatus.general, onToggle: function () { return toggleAccordion("general"); } },
                        React.createElement(Row, null,
                            React.createElement(Col, { xs: 12, md: 6 },
                                React.createElement(Controller, { name: "agencyPrefix", control: control, render: function (_a) {
                                        var _b;
                                        var field = _a.field;
                                        return (React.createElement(RecekSelect, __assign({ labelId: "ui-br-agency.publisher-prefix-range.field.label.agencyPrefix" }, field, { value: field.value ? field.value.id : "", disabled: editMode, onChange: function (e) {
                                                var selected = getAgencyPrefixById(e.target.value);
                                                field.onChange(selected);
                                            }, error: ((_b = serverFieldErrors.agencyPrefix) === null || _b === void 0 ? void 0 : _b.length) ? (React.createElement(ExpandableFieldErrors, { errors: serverFieldErrors.agencyPrefix })) : undefined, required: true }),
                                            React.createElement("option", { value: "" }, " "),
                                            ((data === null || data === void 0 ? void 0 : data.items) || [])
                                                .filter(function (option) { return option != null; })
                                                .map(function (option) { return (React.createElement("option", { key: option.id, value: option.id },
                                                option.internationalPrefix.agency
                                                    ? option.internationalPrefix.agency.toString()
                                                    : "N/A",
                                                " ",
                                                option.internationalPrefix.value,
                                                "-",
                                                option.value)); })));
                                    } }))),
                        !editMode && (React.createElement(Row, null,
                            React.createElement(Col, { xs: 12, md: 6 },
                                React.createElement(Controller, { name: "magnitude", control: control, render: function (_a) {
                                        var _b;
                                        var field = _a.field;
                                        return (React.createElement(RecekSelect, __assign({ labelId: "ui-br-agency.publisher-prefix-range.select.label.magnitude" }, field, { onChange: function (e) {
                                                return field.onChange(Number(e.target.value));
                                            }, disabled: !selectedAgencyPrefixId || isMagnitudeLoading, error: ((_b = serverFieldErrors.magnitude) === null || _b === void 0 ? void 0 : _b.length) ? (React.createElement(ExpandableFieldErrors, { errors: serverFieldErrors.magnitude })) : undefined, required: true }), (magnitudeData === null || magnitudeData === void 0 ? void 0 : magnitudeData.minMagnitude) != null &&
                                            (magnitudeData === null || magnitudeData === void 0 ? void 0 : magnitudeData.maxMagnitude) != null ? (Array.from({
                                            length: magnitudeData.maxMagnitude -
                                                magnitudeData.minMagnitude +
                                                1,
                                        }, function (_, i) {
                                            var value = magnitudeData.minMagnitude + i;
                                            return (React.createElement("option", { key: value, value: value }, (Math.pow(10, value)).toLocaleString("cs-CZ")));
                                        })) : (React.createElement("option", { value: "", disabled: true }, " "))));
                                    } })))),
                        React.createElement(Row, null,
                            React.createElement(Col, { xs: 12, md: 6 },
                                React.createElement(Controller, { name: "start", control: control, render: function (_a) {
                                        var _b, _c;
                                        var field = _a.field;
                                        return (React.createElement(RecekTextField, __assign({}, field, { labelId: "ui-br-agency.publisher-prefix-range.field.label.start", disabled: editMode, error: ((_b = serverFieldErrors.start) === null || _b === void 0 ? void 0 : _b.length) ? (React.createElement(ExpandableFieldErrors, { errors: serverFieldErrors.start })) : ((_c = errors.start) === null || _c === void 0 ? void 0 : _c.message), required: true })));
                                    } }))),
                        React.createElement(Row, null,
                            React.createElement(Col, { xs: 12, md: 6 },
                                React.createElement(Controller, { name: "end", control: control, render: function (_a) {
                                        var _b, _c;
                                        var field = _a.field;
                                        return (React.createElement(RecekTextField, __assign({}, field, { labelId: "ui-br-agency.publisher-prefix-range.field.label.end", error: ((_b = serverFieldErrors.end) === null || _b === void 0 ? void 0 : _b.length) ? (React.createElement(ExpandableFieldErrors, { errors: serverFieldErrors.end })) : ((_c = errors.end) === null || _c === void 0 ? void 0 : _c.message), required: true })));
                                    } })))))))));
}
export default PublisherPrefixRangeForm;
